// extracted by mini-css-extract-plugin
export default {"sliderWrapper":"Slider_sliderWrapper__TGAWI","roundedLeft":"Slider_roundedLeft__t6JU8","roundedRight":"Slider_roundedRight__tp-3h","sliderValue":"Slider_sliderValue__e1QiD"};